<template>
  <div
    class="xl:w-4/5 md:w-11/12 xl:my-10 md:my-4
     md:mx-auto m-1 bg-gray-50 rounded"
  >
    <EditForm
      :row="Array(headings.length)"
      :headers="headings"
      :submitEdit="submitEdit"
      v-if="show"
    />

    <div class="flex flex-row justify-center p-4 w-full">
      <div class="flex ml-auto">
        <div>
          <h1 class="font-semibold xl:text-xl ">Manage Leaders:</h1>
        </div>
        &nbsp;
        <div>
          <select
            name="Select Year"
            @change="handleSelected($event)"
            class=" xl:text-xl  "
          >
            <option
              v-for="year in years"
              :value="year.id"
              v-bind:key="year.id"
              class="hover:border-orange-600"
              >{{ year.name }}</option
            >
          </select>
        </div>
      </div>
      <t-button
        variant="success"
        class="float-right ml-auto"
        @click="show = true"
        >Insert New Record</t-button
      >
      <br />
    </div>
    <div class="p-4 w-auto">
      <t-alert variant="info" show v-on:hidden="setCookie" v-if="noCookie()">
        When inserting new leader record, you only have to make sure
        mod_code, email, leader and term are correct.
        The other fields can be left blank. <br />
      </t-alert>
    </div>
    <div class="flex">
      <Table
        :items="items"
        :del="del"
        :getTheDataInParent="getTheData"
        :edit="edit"/>
    </div>
  </div>
</template>

<script>
import Table from './Table';
import EditForm from './EditForm';

export default {
  components: {
    Table,
    EditForm,
  },
  mounted() {
    this.getTheData();
  },
  methods: {
    handleSelected(event) {
      this.selectedYear =
        event.target.options[event.target.options.selectedIndex].text;
      this.getTheData();
    },

    getCurrentAcademicYear() {
      const now = new Date()
      let year = now.getFullYear();
      const change = new Date(year + "-" + process.env.LDAP_CHANGE_MM_DD)
      if (now < change) {
        year--;
      }
      return `${year}/${year + 1}`;
    },

    getNextAcademicYear() {
      const now = new Date()
      let year = now.getFullYear() + 1 // +1 for chose next year
      const change = new Date(year + "-" + process.env.LDAP_CHANGE_MM_DD)
      if (now < change) {
        year--;
      }
      return `${year}/${year + 1}`;
    },

    async getTheData() {
      const res = await fetch(
        `${process.env.VUE_APP_API_URL}/get_leaders`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            year: this.selectedYear,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      const ret = await res.json();
      if (!ret.success) {
        throw res.error;
      }
      this.items = await ret.data;
      console.log(this.items);
      this.getHeadings();
    },

    async del(row) {
      console.log(JSON.stringify({row: row, year: this.selectedYear}));
      const res = await fetch(
        `${process.env.VUE_APP_API_URL}/delete_mod_leader_record`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            row: row,
            year: this.selectedYear,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    getHeadings: function() {
      try {
        const i = Object.keys(this.items).map((key) => {
          return [Number(key), this.items[key]];
        });

        this.headings = Object.keys(i[0][1]);
        console.log(this.headings);
      } catch (_e) {}
    },

    submitEdit(edit) {
      if (edit === 'cancel') {
        this.show = false;
        return;
      }

      console.log(edit);
      this.show = false;

      this.insert(edit).then((res) => {
        if (res.ok) {
          console.log(res);
          this.$vToastify.success('Successfully carried out edit');
          this.getTheData();
        } else {
          this.$vToastify.error('Could not edit, see console for details');
          console.error(res);
        }
      });
    },

    async insert(edit) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/insert_leader_row`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            edit: edit,
            year: this.selectedYear,
            headings: this.headings,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    async edit(oldRow, newRow) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/edit_leader_row`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            oldRow: oldRow,
            newRow: newRow,
            year: this.selectedYear,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },
    setCookie() {
      this.$cookies.set('ManageLeaders-infobox', 'dismissed', 'infinity');
    },
    noCookie() {
      return !(this.$cookies.get('ManageLeaders-infobox') === 'dismissed');
    },
  },
  data() {
    return {
      headings: [],
      show: false,
      items: [],
      selectedYear: this.getCurrentAcademicYear(),
      years: [
        {name: this.getCurrentAcademicYear(), id: 1},
        {name: this.getNextAcademicYear(), id: 2},
      ],
    };
  },
};
</script>

<style></style>
